document.documentElement.classList.add('js');
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-lux-product]').forEach(root => {
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-product-variants]').textContent); } catch { return; }
    const mainImage = root.querySelector('[data-gallery-main]');
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    let pendingImage = 0;
    const switchImage = (src, alt) => {
      if (!mainImage || !src) return;
      const request = ++pendingImage;
      const preload = new Image();
      preload.onload = () => {
        if (request !== pendingImage) return;
        mainImage.src = src;
        mainImage.removeAttribute('srcset');
        if (alt) mainImage.alt = alt;
      };
      preload.src = src;
    };
    thumbs.forEach(thumb => thumb.addEventListener('click', () => {
      switchImage(thumb.dataset.full, thumb.dataset.imageAlt);
      thumbs.forEach(item => { item.classList.toggle('is-active', item === thumb); item.setAttribute('aria-pressed', String(item === thumb)); });
    }));
    const qty = root.querySelector('[data-qty-input]');
    const changeQuantity = delta => { if (qty) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + delta); };
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => changeQuantity(-1));
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => changeQuantity(1));
    const groups = Array.from(root.querySelectorAll('[data-option-group]'));
    const variantInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const add = root.querySelector('[data-add-button]');
    const label = root.querySelector('[data-add-label]');
    const status = root.querySelector('[data-product-status]');
    const syncVariant = () => {
      const options = groups.map(group => group.querySelector('.is-selected')?.dataset.optionValue);
      const variant = variants.find(item => options.every((option, i) => String(item.options[i]) === option));
      variantInput.value = variant ? variant.id : '';
      add.disabled = !variant || !variant.available;
      label.textContent = !variant ? root.dataset.unavailableLabel : variant.available ? root.dataset.addLabel : root.dataset.soldOutLabel;
      status.textContent = !variant ? root.dataset.statusUnavailable : variant.available ? root.dataset.statusAvailable : root.dataset.statusSoldOut;
      if (!variant) return;
      price.textContent = variant.price_formatted;
      const onSale = variant.compare_at_price > variant.price;
      compare.textContent = onSale ? variant.compare_formatted : '';
      compare.classList.toggle('is-hidden', !onSale);
      if (variant.featured_media_url) {
        const thumb = thumbs.find(item => String(item.dataset.mediaId) === String(variant.featured_media_id));
        switchImage(variant.featured_media_url, thumb?.dataset.imageAlt);
        thumbs.forEach(item => { item.classList.toggle('is-active', item === thumb); item.setAttribute('aria-pressed', String(item === thumb)); });
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      variantInput.dispatchEvent(new Event('change', {bubbles:true}));
    };
    groups.forEach(group => group.querySelectorAll('[data-option-value]').forEach(button => button.addEventListener('click', () => {
      group.querySelectorAll('[data-option-value]').forEach(item => { item.classList.toggle('is-selected', item === button); item.setAttribute('aria-pressed', String(item === button)); });
      group.querySelector('[data-selected-option]').textContent = button.textContent.trim();
      syncVariant();
    })));
    const zoom = root.querySelector('[data-gallery-zoom]');
    const lightbox = root.querySelector('[data-product-lightbox]');
    const lightboxImage = root.querySelector('[data-lightbox-image]');
    if (zoom && lightbox && lightboxImage && mainImage) {
      zoom.addEventListener('click', () => {
        lightboxImage.src = mainImage.currentSrc || mainImage.src;
        lightboxImage.alt = mainImage.alt;
        lightbox.hidden = false;
        lightbox.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
      lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
      lightbox.addEventListener('close', () => { lightbox.hidden = true; document.documentElement.style.overflow = ''; zoom.focus(); });
    }
  });
  const button = document.querySelector('[data-luxv7-menu-button]');
  const menu = document.querySelector('[data-luxv7-mobile-menu]');
  if (!button || !menu) return;
  const setOpen = open => {
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute('aria-label', open ? button.dataset.closeLabel : button.dataset.openLabel);
    menu.hidden = !open;
  };
  button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'));
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setOpen(false)));
  document.addEventListener('click', event => { if (!menu.contains(event.target) && !button.contains(event.target)) setOpen(false); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !menu.hidden) { setOpen(false); button.focus(); } });
  document.addEventListener('focusin', event => { if (!menu.contains(event.target) && !button.contains(event.target)) setOpen(false); });
  window.matchMedia('(min-width: 901px)').addEventListener('change', event => { if (event.matches) setOpen(false); });
});
